import { EditEntrepreneurFields, EditOrganisationFields } from '../../../organization/organisation.model';
import { IForm } from '../../../../core/modules/business-process/business-process.types';

export enum RegistrationTypes {
  EDS = 0,
  SMS = 1,
}

export interface BpVerificationTypeForm extends IForm {
  fields: BpVerificationTypeFields;
  formKey: 'verification-type-form';
}
export interface BpVerificationTypeFields {
  verifyBySms: boolean;
}

export interface BpSubjectForm extends IForm {
  fields: BpSubjectFields;
  formKey: 'subject-form';
}
export interface BpSubjectFields {
  signature: string;
  salt: string;
}

export interface RegisterEntrepreneurForm extends IForm {
  fields: RegisterEntrepreneurFields;
  formKey: 'registration-entrepreneur-form';
}
export interface RegisterOrganisationForm extends IForm {
  fields: RegisterOrganisationFields;
  formKey: 'registration-organisation-form';
}

export interface RegisterEntrepreneurFields extends EditEntrepreneurFields {
  confirmOffer: boolean;
  rootLogin: string;
  password: string;
  type: '1';
}

export interface RegisterOrganisationFields extends EditOrganisationFields {
  confirmOffer: boolean;
  rootLogin: string;
  password: string;
  type: '0';
}
